// extracted by mini-css-extract-plugin
export default {"modalHeader":"modalHeader__dWR0c"};